import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ClientList from "../components/home/ClientList";
import RecentActivity from "../components/home/RecentActivity";
import { gridGenerator } from "../helper/helper";
import profilePic from "../assets/images/Slider_2.jpg";
import awarPic from "../assets/images/award_1.jpg";
import urlConfig from "../helper/urlConfig";
import {
  getAbout,
  getAboutCounterConfig,
  getCurrentabout,
  getCurrentaboutConfig,
} from "../redux/about/aboutSlice";
import {
  getClientData,
  getClientList,
  getHomeConfig,
  getHomeConfigData,
  getHomeSliderData,
  getHomeSliderList,
  getRecentActivityData,
  getRecentActivityList,
} from "../redux/home/homeSlice";
import { getMenu, getMenuByPath } from "../redux/menu/menuSlice";
import {
  getCurrentMenuWisePageConfig,
  getCurrentSelectedMenuID,
  getMenuWisePageConfig,
  setCurrentSelectedMenuID,
} from "../redux/menu/menuWisePageConfigSlice";
import { getScreenSize } from "../redux/theme/themeSlice";
import Carousel from "better-react-carousel";
import academiaImg from "../assets/images/academia.jpg";
import academiaImg1 from "../assets/images/academia.png";
import professionalImg from "../assets/images/professional.png";
import researchGateImg from "../assets/images/researchgate.png";
import googlescholarImg from "../assets/images/googlescholar.png";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import LatestNewsWidget from "../components/newsAndEvents/LatestNewsWidget";
import { ReactTyped as Typed } from "react-typed";
import CountUp from "react-countup";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import CustomTooltip from "../components/CustomTooltip";
import GoogleScholarBarChart from "../components/GoogleScholarBarChart";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPageConfig = useSelector(getCurrentMenuWisePageConfig);
  const currentMenuID = useSelector(getCurrentSelectedMenuID);
  const sliderData = useSelector(getHomeSliderData);
  const configData = useSelector(getHomeConfigData);
  const [activeSlide, setActiveSlide] = useState(0);
  const aboutConfigs = useSelector(getCurrentaboutConfig);
  const [gridGeneratorClassName, setGridGeneratorClassName] = useState("");
  const screenSize = useSelector(getScreenSize);
  const clientData = useSelector(getClientData);

  const aboutData = useSelector(getCurrentabout);
  const aboutCounters = (aboutConfigs && aboutConfigs.counters) || [];
  const barChartData = aboutCounters.map((item) => ({
    title: item.title.charAt(0).toUpperCase() + item.title.slice(1),
    count: parseInt(item.count.replace(/\D/g, "")) || 0,
  }));

  let slideInterval;
  let slideIntervalTime = 7000;
  let autoScroll = true;

  // Add refs for the content sections to measure height
  const bioContentRef = useRef(null);
  const newsWidgetRef = useRef(null);

  useEffect(() => {
    dispatch(getMenuWisePageConfig(currentMenuID));
    dispatch(getHomeSliderList());
    dispatch(getHomeConfig());
    dispatch(getClientList());

    dispatch(getAbout());
    dispatch(getAboutCounterConfig());
  }, []);

  const [slides, setSlider] = useState([]);
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    const getSliders = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_PUBLIC_URL}api/sliders`,
        {
          signal,
        }
      );
      // console.log(res)

      if (res.status === 204) {
        setSlider([]);
      } else {
        setSlider(res.data.data);
      }
    };
    getSliders();
    // console.log(latestNews)
    return () => {
      abortController.abort();
    };
  }, []);

  const nextSlide = () => {
    setActiveSlide(activeSlide == sliderData.length - 1 ? 0 : activeSlide + 1);
  };
  function auto() {
    slideInterval = setInterval(nextSlide, slideIntervalTime);
  }

  useEffect(() => {
    setActiveSlide(0);
  }, []);

  useEffect(() => {
    if (autoScroll) {
      auto();
    }
    return () => clearInterval(slideInterval);
  }, [activeSlide]);

  useEffect(() => {
    setGridGeneratorClassName(
      gridGenerator(
        aboutConfigs &&
          aboutConfigs.configs &&
          aboutConfigs.configs.column_count
      )
    );
  }, [aboutConfigs]);

  // Function to handle dynamic height adjustment - improved to set height on news widget
  const adjustHeight = () => {
    if (bioContentRef.current && newsWidgetRef.current) {
      const bioHeight = bioContentRef.current.offsetHeight;
      // Set the height of the news widget container to match the bio content
      newsWidgetRef.current.style.height = `${bioHeight}px`;
    }
  };

  // Add an effect to adjust height when content changes or on window resize
  useEffect(() => {
    // Allow the DOM to render first before measuring
    setTimeout(() => {
      adjustHeight();
    }, 300);

    // Add window resize listener to readjust on screen changes
    window.addEventListener("resize", adjustHeight);

    // Cleanup
    return () => {
      window.removeEventListener("resize", adjustHeight);
    };
  }, [aboutData]);

  const handleRedirect = (e, path, type) => {
    e.preventDefault();
    dispatch(getMenuByPath(path)).then((res) => {
      dispatch(setCurrentSelectedMenuID(res && res.payload.id));
    });
    navigate("/" + path, { replace: true, state: { type: type } });
  };

  // Set the Y-axis domain for the bar chart to always be [100, 10000]
  const yDomain = [100, 10000];

  const [showBarChart, setShowBarChart] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowBarChart(true), 200);
  }, []);

  const scholarChartData = aboutCounters
    .filter((item) => item.type === "GOOGLE_SCHOLAR")
    .map((item) => ({
      year: parseInt(item.year),
      count: parseInt(item.count.replace(/\D/g, "")) || 0,
    }))
    .sort((a, b) => a.year - b.year);

  return (
    <div className="w-full mx-auto min-h-screen mb-6">
      <>
        {/* Replace slider/banner section with a single image and updated text */}
        <div className="w-full">
          <div className="home-container">
            <div className="relative">
              <img
                className="w-full h-auto md:h-[600px] 2xl:h-[700px] object-cover"
                style={{ objectPosition: "center top" }}
                src={profilePic}
                alt="Profile"
              />
              <div
                className="w-full absolute my-12 md:my-0 md:w-[50%] md:bg-black/50 md:left-0 
                md:top-0 md:h-full flex items-start flex-col justify-center px-4 md:px-12"
              >
                <p className="flex items-start flex-col w-full text-left">
                  <span className="font-normal text-sm md:text-xl lg:text-2xl text-center md:text-left text-white relative py-2 md:py-3">
                    Hello! I AM
                  </span>
                  <span className="font-bold py-3 text-3xl md:text-4xl lg:text-5xl text-white text-center md:text-left">
                    Abdullah Al-Muyeed
                  </span>
                  <span className="font-normal text-sm md:text-xl lg:text-2xl text-center md:text-left text-white relative py-2 md:py-3">
                    A{" "}
                    <Typed
                      strings={[
                        "Teacher",
                        "Researcher",
                        "Development Practitioner",
                      ]}
                      typeSpeed={50}
                      backSpeed={30}
                      loop
                    />
                  </span>
                </p>
                <div className="flex gap-4 mt-4">
                  <button
                    className="rounded-full px-5 py-2 text-white bg-sky-500 hover:bg-sky-600 z-[10] max-w-fit"
                    onClick={(e) => handleRedirect(e, "about", "about")}
                  >
                    About Me
                  </button>
                  <button
                    className="rounded-full px-5 py-2 text-white bg-sky-500 hover:bg-sky-600 z-[10] max-w-fit"
                    onClick={(e) =>
                      handleRedirect(e, "recent-activities", "activities")
                    }
                  >
                    Recent Activities
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Replace "What is it about" section */}
        <div className="flex flex-col lg:flex-row w-full bg-sky-500 text-white py-16 px-8 ">
          <div className="flex-1 flex flex-col items-center justify-center text-center">
            <img
              src={awarPic}
              alt="Profile"
              className="w-40 h-40 rounded-full object-cover border-4 border-white mb-4"
            />
            <h2 className="text-2xl font-bold">Abdullah Al-Muyeed</h2>
            <p className="text-lg p-2">Chief Operating Officer (COO)</p>
            <p className="text-sm p-2">CWIS-FSM Support Cell</p>
            <p className="text-sm mb-6">
              Department of Public Health Engineering (DPHE)
            </p>

            <div className="flex gap-6 mt-6">
              <a
                href="https://scholar.google.com/citations?user=pQZkFOoAAAAJ&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-16 h-16 bg-sky-900 hover:bg-sky-700 rounded-lg shadow-lg"
              >
                <img
                  src={require("../assets/images/googlescholar.png")}
                  alt="Google Scholar"
                  className="w-10 h-10"
                />
              </a>
              <a
                href="https://www.researchgate.net/profile/Abdullah-Al-Muyeed"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-16 h-16 bg-sky-900 hover:bg-sky-700 rounded-lg shadow-lg"
              >
                <img
                  src={require("../assets/images/researchgate.png")}
                  alt="ResearchGate"
                  className="w-10 h-10"
                />
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-16 h-16 bg-sky-900 hover:bg-sky-700 rounded-lg shadow-lg"
              >
                <i className="uil uil-linkedin text-white text-3xl"></i>
              </a>
            </div>
          </div>
          {/* Thinner and taller bar in the middle */}
          <div className="w-0.5 h-auto bg-white mx-auto my-6"></div>
          <div className="flex-1 flex flex-col justify-center pl-2">
            <h3 className="text-2xl font-bold mb-4 text-center relative">
              Biography
              <span className="block mt-2 mx-auto w-36 h-0.5 bg-white"></span>
            </h3>
            <p className="text-sm leading-relaxed text-justify">
              Dr. Abdullah Al-Muyeed is a leading development professional with
              over 20 years of expertise in environmental engineering and
              sustainable development. As Chief Operating Officer (COO) of the
              CWIS-FSM Support Cell at Bangladesh’s Department of Public Health
              Engineering (DPHE), he drives nationwide progress toward SDG 6.2,
              leading institutional reforms and managing government-led
              sanitation initiatives, supported by the Bill & Melinda Gates
              Foundation. Previously, Dr. Muyeed served as Head of Policy and
              Advocacy at WaterAid Bangladesh, where he pioneered the
              co-composting model of faecal sludge and solid waste—now featured
              in Bangladesh’s 8th Five Year Plan and scaled across South Asia
              and Africa. At the forefront of innovation, Dr. Muyeed champions
              NextGen sanitation technologies, including pyrolysis,
              gasification, plasma systems, and the OmniProcessor. His
              leadership has shaped national WASH policies and advanced
              transparent, accountable project management. Recognized globally,
              he has received the Innovation Ambassador Award (2016), the
              Hackathon Award (2020) for a COVID-19 Tracker app, and was named a
              2023 IWA Inclusive Urban Sanitation Champion for Service Delivery
              (Treatment). An accomplished author, his award-winning book Water
              and Environmental Engineering reflects his commitment to
              sustainable solutions and environmental leadership.
            </p>
          </div>
        </div>

        {/* career */}
        <div className="flex items-center flex-col lg:flex-row">
          <div className="flex-1 px-24 py-16 academia flex flex-col justify-center items-center gap-6">
            {/* <p className="text-normal text-2xl font-semibold z-[10] text-white text-center">
              Without hardwork and discipline it is difficult to be a top
              professional
            </p> */}
            {/* <button
              className="rounded-full px-5 py-2 bg-indigo-500 hover:bg-indigo-700 z-[10] max-w-fit"
              onClick={(e) => handleRedirect(e, "portfolio", "professional")}
            >
              Professional Attribute
            </button> */}
            {/* <div className="w-full flex items-center gap-3 flex-row z-[10] flex-wrap">
              {clientData &&
                clientData.clientListData &&
                clientData.clientListData.length > 0 &&
                clientData.clientListData.map((item, index) => (
                  <div key={index}>
                    <img
                      crossOrigin="anonymous"
                      src={urlConfig.baseUrl + item.img}
                      className="w-[50px] h-[50px] rounded-2xl"
                      alt={Math.random()}
                    />
                  </div>
                ))}
            </div> */}

            {/* Google Scholar Section */}
            {/* <div className="w-full flex flex-col items-center justify-center mt-8 z-[10]">
              <h3 className="text-xl font-bold text-white mb-4">
                Google Scholar
              </h3>
              <div className="w-full flex flex-row justify-center gap-6 mb-6 flex-wrap">
                {aboutCounters
                  .filter((item) => item.type === "GOOGLE_SCHOLAR")
                  .map((item, idx) => (
                    <div
                      key={`gs-${idx}`}
                      className="flex flex-col items-center bg-white/10 rounded-xl px-6 py-3 min-w-[100px] transform hover:scale-105 transition-transform duration-300"
                    >
                      <span className="text-3xl font-bold text-white">
                        <CountUp
                          end={parseInt(item.count.replace(/\D/g, "")) || 0}
                          duration={1.2}
                        />
                      </span>
                      <span className="text-sm font-semibold text-yellow-400 mt-2">
                        {item.title}
                      </span>
                    </div>
                  ))}
              </div>
            </div> */}

            {/* <div className="w-full flex flex-col items-center justify-center mt-8 z-[10]">
  <h3 className="text-xl font-bold text-white mb-4">Citations Per Year</h3>
  <div className="w-full bg-white/10 rounded-xl p-3">
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={scholarChartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
        <XAxis dataKey="year" stroke="#fff" />
        <YAxis stroke="#fff" />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="count" fill="#facc15" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
</div> */}

            <div className="w-full flex flex-col items-center justify-center mt-8 z-[10]">
              <h3 className="text-xl font-bold text-white mb-4">
                Google Citations Per Year
              </h3>

              {/* Scrollable container with scrollbar styling */}
              {/* <div className="w-full bg-white/10 rounded-xl p-4 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-700">
                <div style={{ width: `${scholarChartData.length * 60}px` }}>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={scholarChartData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                      <XAxis
                        dataKey="year"
                        stroke="#fff"
                        tick={{ fill: "#fff", fontSize: 12 }}
                        interval={0}
                      />
                      <YAxis
                        stroke="#fff"
                        tick={{ fill: "#fff", fontSize: 12 }}
                        width={40}
                      />
                      <Tooltip content={<CustomTooltip />} />
                      <Bar
                        dataKey="count"
                        fill="#FACC15"
                        barSize={40}
                        radius={[4, 4, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div> */}

<GoogleScholarBarChart scholarChartData = {scholarChartData} />



            </div>
          </div>
          <div className="flex-1 px-24 py-16 professional flex flex-col justify-center items-center gap-6">
            <p className="text-normal text-2xl font-semibold z-[10] text-white text-center">
              Researchgate publications and citations
            </p>

            {/* ResearchGate Section */}
            <div className="w-full flex flex-col items-center justify-center mt-8 z-[10]">
              <div className="w-full flex flex-row justify-center gap-6 mb-6 flex-wrap">
                {aboutCounters
                  .filter((item) => item.type === "RESEARCH_GATE")
                  .map((item, idx) => (
                    <div
                      key={`rg-${idx}`}
                      className="flex flex-col items-center bg-white/10 rounded-xl px-6 py-3 min-w-[100px] transform hover:scale-105 transition-transform duration-300"
                    >
                      <span className="text-3xl font-bold text-white">
                        <CountUp
                          end={parseInt(item.count.replace(/\D/g, "")) || 0}
                          duration={1.2}
                        />
                      </span>
                      <span className="text-sm font-semibold text-yellow-400 mt-2">
                        {item.title}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* blog */}
        {/* <div className="flex items-center flex-col lg:flex-row">
          <div className="flex-1 px-24 py-16 blog flex flex-col justify-center items-center gap-6">
            <p className="text-3xl font-semibold z-[10] text-white text-center">
              The best form of expression is BLOGING
            </p>
            <button
              className="rounded-full px-5 py-2 bg-cyan-500 hover:bg-cyan-700 z-[10] max-w-fit"
              onClick={(e) => handleRedirect(e, "blog")}
            >
              My Blogs
            </button>
          </div>
        </div> */}

        {/* book and news */}
        {/* <div className="flex items-center flex-col lg:flex-row">
          <div className="flex-1 px-24 py-16 books flex flex-col justify-center items-center gap-6">
            <p className="text-3xl font-semibold z-[10] text-white text-center">
              Research is formalized curiosity. It is poking and prying with
              purpose
            </p>
            <button
              className="rounded-full px-5 py-2 bg-teal-500 hover:bg-teal-700 z-[10] max-w-fit"
              onClick={(e) => handleRedirect(e, "books-publications")}
            >
              Books & Publications
            </button>
          </div>
          <div className="flex-1 px-24 py-16 news flex flex-col justify-center items-center gap-6">
            <p className="text-3xl font-semibold z-[10] text-white text-center">
              News is what somebody, somewhere wants to suppress
            </p>
            <button
              className="rounded-full px-5 py-2 bg-pink-600 hover:bg-pink-700 z-[10] max-w-fit"
              onClick={(e) => handleRedirect(e, "news-events")}
            >
              News & Events
            </button>
          </div>
        </div> */}

        {/* contact */}
        <div className="flex items-center flex-col lg:flex-row">
          <div className="flex-1 px-24 py-16 contact flex flex-col justify-center items-center gap-6">
            <h2 className="text-white font-bold text-4xl z-[10] text-center">
              Get in Touch
            </h2>
            <p className="text-normal font-semibold z-[10] text-white text-center">
              I would love to hear from you
            </p>
            <button
              className="rounded-full px-5 py-2 bg-indigo-500 hover:bg-indigo-700 z-[10] max-w-fit"
              onClick={(e) => handleRedirect(e, "contact")}
            >
              Contact Me
            </button>
            <div className="w-full  flex  gap-3 md:flex-row flex-wrap px-2 md:px-4 justify-center z-[10]">
              <a
                href="https://www.facebook.com/aamuyeed"
                target="_blank"
                className="uil uil-facebook text-white bg-indigo-500 hover:bg-indigo-700  rounded-[50%] p-2 flex items-center justify-center hover:cursor-pointer"
              ></a>
              <a
                href="https://www.youtube.com/channel/UC2yAPnC4e4NQrn2H9f_2kjA"
                target="_blank"
                className="uil uil-youtube text-white bg-indigo-500 hover:bg-indigo-700 rounded-[50%] p-2 flex items-center justify-center hover:cursor-pointer"
              ></a>
              <a
                href="https://www.linkedin.com/in/amuyeed/"
                target="_blank"
                className="uil uil-linkedin text-white bg-indigo-500 hover:bg-indigo-700  rounded-[50%] p-2 flex items-center justify-center hover:cursor-pointer"
              ></a>
              <a
                href="https://twitter.com/aamuyeed"
                target="_blank"
                className="uil uil-twitter text-white bg-indigo-500 hover:bg-indigo-700  rounded-[50%] p-2 flex items-center justify-center hover:cursor-pointer"
              ></a>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Home;
